import React from 'react';
import Icon from './Icon';
import { useDispatch } from 'react-redux';
import { setLoginModalOpen } from '../Actions/Login.action';

// TODO

const TopLinkMenu = () => {
  const dispatch = useDispatch();

  return (
    <button
      className="top-link__menu"
      onClick={() => dispatch(setLoginModalOpen(true))}
    >
      <Icon name="Person" size={24} className="top-link__menu-user-icon" />
      <div className="top-link__menu-label">Sign in</div>
    </button>
  );
};

export default TopLinkMenu;
